import CustomSelect, { CustomSelectItem } from "components/custom-ui/CustomSelect";

/**
 * @name StatesCustomSelect
 * @function
 * @param {STRING|NULL} value - the name of a state for a selected state
 * @param {Function|NULL} onChange - A function that gets called and passed a value when the select value changes.
 * @extends React.Component
 * @exported true
 * @description A custom select component that shows the states of the United States.
 * @example 
 *  <StatesCustomSelect value={ payee.financialInstitutionState } onChange={ onChange("financialInstitutionState") }/>
 */
export default function StatesCustomSelect(props) {
    return (
    <CustomSelect active={ props.active } value={ props.value } onChange={ props.onChange }>
        <CustomSelectItem value="alabama">ALABAMA</CustomSelectItem>
        <CustomSelectItem value="alaska">ALASKA</CustomSelectItem>
        <CustomSelectItem value="arizona">ARIZONA</CustomSelectItem>
        <CustomSelectItem value="arkansas">ARKANSAS</CustomSelectItem>
        <CustomSelectItem value="california">CALIFORNIA</CustomSelectItem>
        <CustomSelectItem value="colorado">COLORADO</CustomSelectItem>
        <CustomSelectItem value="connecticut">CONNECTICUT</CustomSelectItem>
        <CustomSelectItem value="delaware">DELAWARE</CustomSelectItem>
        <CustomSelectItem value="florida">FLORIDA</CustomSelectItem>
        <CustomSelectItem value="georgia">GEORGIA</CustomSelectItem>
        <CustomSelectItem value="hawaii">HAWAII</CustomSelectItem>
        <CustomSelectItem value="idaho">IDAHO</CustomSelectItem>
        <CustomSelectItem value="illinois">ILLINOIS</CustomSelectItem>
        <CustomSelectItem value="indiana">INDIANA</CustomSelectItem>
        <CustomSelectItem value="iowa">IOWA</CustomSelectItem>
        <CustomSelectItem value="kansas">KANSAS</CustomSelectItem>
        <CustomSelectItem value="kentucky">KENTUCKY</CustomSelectItem>
        <CustomSelectItem value="louisiana">LOUISIANA</CustomSelectItem>
        <CustomSelectItem value="maine">MAINE</CustomSelectItem>
        <CustomSelectItem value="maryland">MARYLAND</CustomSelectItem>
        <CustomSelectItem value="massachusetts">MASSACHUSETTS</CustomSelectItem>
        <CustomSelectItem value="michigan">MICHIGAN</CustomSelectItem>
        <CustomSelectItem value="minnesota">MINNESOTA</CustomSelectItem>
        <CustomSelectItem value="mississippi">MISSISSIPPI</CustomSelectItem>
        <CustomSelectItem value="missouri">MISSOURI</CustomSelectItem>
        <CustomSelectItem value="montana">MONTANA</CustomSelectItem>
        <CustomSelectItem value="nebraska">NEBRASKA</CustomSelectItem>
        <CustomSelectItem value="nevada">NEVADA</CustomSelectItem>
        <CustomSelectItem value="new hampshire">NEW HAMPSHIRE</CustomSelectItem>
        <CustomSelectItem value="new jersey">NEW JERSEY</CustomSelectItem>
        <CustomSelectItem value="new mexico">NEW MEXICO</CustomSelectItem>
        <CustomSelectItem value="new york">NEW YORK</CustomSelectItem>
        <CustomSelectItem value="north carolina">NORTH CAROLINA</CustomSelectItem>
        <CustomSelectItem value="north dakota">NORTH DAKOTA</CustomSelectItem>
        <CustomSelectItem value="ohio">OHIO</CustomSelectItem>
        <CustomSelectItem value="oklahoma">OKLAHOMA</CustomSelectItem>
        <CustomSelectItem value="oregon">OREGON</CustomSelectItem>
        <CustomSelectItem value="pennsylvania">PENNSYLVANIA</CustomSelectItem>
        <CustomSelectItem value="rhode island">RHODE ISLAND</CustomSelectItem>
        <CustomSelectItem value="south carolina">SOUTH CAROLINA</CustomSelectItem>
        <CustomSelectItem value="south dakota">SOUTH DAKOTA</CustomSelectItem>
        <CustomSelectItem value="tennessee">TENNESSEE</CustomSelectItem>
        <CustomSelectItem value="texas">TEXAS</CustomSelectItem>
        <CustomSelectItem value="utah">UTAH</CustomSelectItem>
        <CustomSelectItem value="vermont">VERMONT</CustomSelectItem>
        <CustomSelectItem value="virginia">VIRGINIA</CustomSelectItem>
        <CustomSelectItem value="washington">WASHINGTON</CustomSelectItem>
        <CustomSelectItem value="west virginia">WEST VIRGINIA</CustomSelectItem>
        <CustomSelectItem value="wisconsin">WISCONSIN</CustomSelectItem>
        <CustomSelectItem value="wyoming">WYOMING</CustomSelectItem>
    </CustomSelect>
    );
}